import React, { useRef } from 'react'
import ThisProject from '../ThisProject';
import { Gallery } from '../../components/imports';

// TODO ENABLE
// import MotionContent from '../../components/containers/MotionContent';
// import { ImageMedia } from '../../components/imports';

const Content = () => {

  const heroRef = useRef(null);

  return (
    <ThisProject>
      {({ thisProject, projectId, prLink }) => (
        <div className='projectContent min-h-screen'>
          <h1>{thisProject.client}</h1>

          <div ref={heroRef}>
            <Gallery content={[
              { type: 'image', src: require("./assets/Sbd_R10-1.jpg") },
              { type: 'image', src: require("./assets/Sbdollz_Stills (5).jpg") },
              { type: 'video', src: require("./assets/Sbd_Animation001.mp4") },
            ]}
            />
          </div>
        </div>
      )}
    </ThisProject>
  )
}

export default Content